module.exports = __webpack_public_path__ + "static/media/carousel.0df99175.svg";